import { useEffect } from 'react'

import { AppHTTPRequest, appHTTPRequestBus } from 'src/core/classes/eventBuses/AppEventBus'

export const EventBusSubscriber = () => {
  useEffect(() => {
    return appHTTPRequestBus.subscribe(AppHTTPRequest.response401, () => {
      const currentPathName = window.location.pathname
      const url = currentPathName.length > 1 ? `/#redirectPage=${currentPathName}` : '/'
      if (url !== window.location.pathname) {
        window.location.assign(url)
      }
    })
  }, [])

  return null
}
